<template>
    <div class="PlainButton --global-clickable" :style="{ backgroundColor: color }" @click="$emit('click')">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#5DB1CF'
        }
    }
};
</script>

<style lang="scss" scoped>
.PlainButton {
    // background-color: #5DB1CF;
    padding: 1em 2em;
    border-radius: 0.5em;
    color: white;
    font-weight: 600;
    text-align: center;
}
</style>
